import ProfImg from "/profImg.webp";
import InsightPdf from "/Projects/InsightPdf/InsightPdf.webp";
import InsightPdf2 from "/Projects/InsightPdf/Pic2.webp";
import InsightPdf3 from "/Projects/InsightPdf/Pic3.webp";

import Wellbeing from "/Projects/Wellbeing/Wellbeing.webp"
import Wellbeing2 from "/Projects/Wellbeing/Pic2.webp"
import Wellbeing3 from "/Projects/Wellbeing/Pic3.webp"

import Trackflow from "/Projects/Trackflow/ss1.webp"
import Trackflow2 from "/Projects/Trackflow/ss2.webp"
import Trackflow3 from "/Projects/Trackflow/ss3.webp"
import Trackflow4 from "/Projects/Trackflow/ss4.webp"

import Smartminds from "/Projects/Smartminds/ss1.webp"
import Smartminds2 from "/Projects/Smartminds/ss2.webp"
import Smartminds3 from "/Projects/Smartminds/ss3.webp"

import SIH from "/Achievements/SIH.webp"
import Recursion from "/Achievements/Recursion.webp"
import Hackhive from "/Achievements/Hackhive.webp"
import UIUX from "/Achievements/UI UX.webp"
import Gits from "/Achievements/GITS.webp"
import Vega from "/Achievements/VEGA.webp"


export const profileData = {
  name: "Farhaan Shaikh",
  roles: ["App Dev", "Web Dev", "Youtuber"],
  contacts: {
    phone: "+91 70211 77410",
    email: "fsfarhaanshaikh7@gmail.com",
    portfolio: "https://portfolio-fsfarhaans-projects.vercel.app",
    linkedin: "https://linkedin.com/in/fsfarhaanshaikh",
    github: "https://github.com/FSfarhaan",
    youtube: "https://www.youtube.com/@FSFarhaanShaikh",
    leetcode: "https://leetcode.com/u/farhaan8d",
    linktree: "https://linktr.ee/farhaanshaikh",
    instagram: "https://www.instagram.com/the_farhaanshaikh"
  },
  profImg: ProfImg,
  summary: "I build scalable, secure web and mobile applications using React.js, React Native, and modern backend systems. With experience in system architecture, API design, and AI integrations, I enjoy turning ideas into impactful solutions. My journey spans leaderships, internships, and multiple hackathon wins, and I continue exploring how GenAI and modern software design can solve real-world problems.",
  education: [
    {
      institution: "Datta Meghe College of Engineering",
      location: "Airoli, Maharashtra",
      degree: "B.E. in Computer Science and Engineering",
      dates: "Nov 2022 - May 2026",
      meta: "AVG CGPA: 8.3"
    },
    {
      institution: "Asadullah Khan English High School & Jr. College",
      location: "Mumbra, Maharashtra",
      degree: "HSC - 85.67% | SSC - 89.90%",
      dates: "Nov 2020 - June 2022"
    }
  ],
  experience: [
    {
      title: "Full Stack developer",
      company: "INCOIS",
      stack: ["MERN", "Leaflet.js", "PostgreSQL", "REST API"],
      dates: "Aug 2025 - Present",
      bullets: [
        "Designed and developed a centralized portal for aggregating geo-referenced fish catch datasets, improving data accessibility for scientific research.",
        "Built modular Excel data ingestion pipelines with classification by species, date, depth, and location, applying secure and scalable backend design principles."
      ],
      keyImpact: "Improved marine research efficiency by building a centralized, scalable portal and automated pipelines for fishery datasets."
    },
    {
      title: "Technical Head",
      company: "CSI DMCE",
      stack: ["MERN", "HTML", "CSS", "Javascript"],
      dates: "July 2025 - Present",
      bullets: [
        "Leading the technical team and overseeing all development, tech initiatives, and project planning within the club.",
        "Mentoring junior developers and organizing technical workshops and hackathons."
      ],
      keyImpact: "Strengthened the club’s technical foundation by leading projects, mentoring juniors, and driving hackathons and workshops."
    },
    {
      title: "Graphic Designer",
      company: "GDSC DMCE",
      stack: ["Figma", "Canva"],
      dates: "July 2023 - July 2024",
      bullets: [
        "Designed visually engaging posters and digital assets for events, workshops, and hackathons."
      ],
      keyImpact: "Enhanced event outreach and engagement through impactful, visually appealing digital designs."
    }
  ],
  projects: [
    {
      name: "WellBeing - AI Mental Health Companion",
      stack: ["React Native", "Expo", "Firebase", "FastAPI", "NLP"],
      date: "March 2025",
      bullets: [
        "Developed a mobile app offering AI-driven emotional support, mood tracking, and gamified self-care, following secure coding standards.",
        "Integrated pre-trained NLP models for sentiment prediction, implemented real-time chat, and scheduled notifications for higher user engagement.",
        "Designed the system to be modular and maintainable, ensuring scalability for future feature additions."
      ],
      githubLink: "https://github.com/FSfarhaan/Peacehub",
      projectImg: [Wellbeing, Wellbeing2, Wellbeing3]
      
    },
    {
      name: "InsightPDF - Smart PDF Analyzer",
      stack: ["React.js", "FastAPI", "NLP", "NLTK", "Groq API", "OCR"],
      date: "Feb 2025",
      bullets: [
        "Developed an AI-powered research paper extraction platform for structured content parsing across multiple document formats.",
        "Utilized FastAPI to build modular NLP and OCR pipelines, enabling section-wise content parsing and structured output across PDFs, DOCs, and TXT files.",
        "Integrated a chatbot interface, dynamic knowledge graph, cross-paper insights, and data visualizations to streamline academic research and enterprise documentation workflows."
      ],
      githubLink: "https://github.com/FSfarhaan/InsightPDF",
      projectImg: [InsightPdf, InsightPdf2, InsightPdf3]
    },
    {
      name: "Smartminds - Tuition management app",
      stack: ["React Native", "Expo", "Firebase", "MERN"],
      date: "August 2025",
      bullets: [
        "Built a cross-platform tuition management app to streamline student records, attendance tracking, and fee management with real-time updates.",
        "Integrated Firebase push notifications for reminders, ensuring timely communication of classes, dues, and important alerts to students and parents.",
        "Designed modular APIs with MongoDB backend for scalability, covering core modules like students, attendance, fees, reminders, and dashboard insights."
      ],
      githubLink: "https://github.com/FSfarhaan/SmartMinds",
      projectImg: [Smartminds, Smartminds2, Smartminds3]
      
    },
    {
      name: "TrackFlow: Smart Delivery Management System",
      stack: ["Next.js", "Typescript", "Tailwind", "MongoDB"],
      date: "Feb 2025",
      bullets: [
        "Built a full-stack delivery tracking platform using Next.js (frontend and backend) and MongoDB, enabling seamless order management, assignment routing, and real-time delivery status updates.",
        "Developed analytics and assignment workflows, including automatic partner assignment, performance metrics, and delivery dashboard insights to optimize logistics efficiency.",
        "Designed for future enhancement, architected with extensibility in mind—supporting potential AI-based route optimization, multi-vendor capabilities, and invoice/billing modules."
      ],
      githubLink: "https://github.com/FSfarhaan/TrackFlow",
      projectImg: [Trackflow, Trackflow2, Trackflow3, Trackflow4]
    },
  ],
  skills: {
    Languages: ["Java", "JavaScript", "TypeScript"],
    Frontend: ["HTML", "CSS", "TailwindCSS", "React.js", "React Native", "Expo", "NextJS", "ShadCN", "GSAP"],
    Backend: ["Node.js", "Express", "JWT", "Socket.io"],
    Database: ["MongoDB", "Firebase"],
    Tools: ["Git", "GitHub", "VS Code", "Figma", "Postman"],
    Other: ["REST API design", "Modular architecture", "Problem-solving", "People Management", "Communication"]
  },
  achievements: [
    {
      title: "Winner, Smart India Hackathon (SIH) 2024",
      detail: "Won the national level hackathon organized by the gov of India",
      icon: "🏆",
      link: "https://www.linkedin.com/posts/fsfarhaanshaikh_smartindiahackathon2024-sih2024-teamastraa-activity-7274450838364770304-WgpO",
      img: SIH,
      position: "Winner"
    },
    {
      title: "Winner, Recursion 5.0 Hackathon",
      detail: "1st place out of 130 teams at a State-level Hackathon",
      icon: "🏆",
      link: "https://www.linkedin.com/posts/fsfarhaanshaikh_hackathon-recursion-rgit-activity-7175918158883524609-TyBo",
      img: Recursion,
      position: "Winner"
    },
    {
      title: "1st Prize, Hackhive 2025 Hackathon",
      detail: "Secured 1st prize in an 8-hour hackathon organized by SHAIDS DMCE.",
      icon: "🏆",
      link: "https://www.linkedin.com/posts/fsfarhaanshaikh_hackhive2025-wewon-aivengers-activity-7313078131924328448-CmZ7",
      img: Hackhive,
      position: "Winner"
    },
    {
      title: "1st Prize, UI UX Competition",
      detail: "Stood 1st prize in UI UX competiton organized by CSI DMCE",
      icon: "🏆",
      link: "https://www.linkedin.com/posts/fsfarhaanshaikh_im-glad-to-announce-that-ive-ranked-1st-activity-7100889675803865088-b9HY",
      img: UIUX,
      position: "Winner"
    },
    {
      title: "Top 6 in Hackathon 2.0",
      detail: "Finalist in a 2 day Hackkathon organized by GITS DMCE",
      icon: "",
      link: "https://www.linkedin.com/posts/fsfarhaanshaikh_hackathon-gitsdmce-innovation-activity-7178763830154444801-JKwg",
      img: Gits,
      position: "Top 6"
    },
    {
      title: "Secured top 10 position in Vega",
      detail: "Being the finalist in a 24 hours Hackathon ",
      icon: "",
      link: "https://www.linkedin.com/posts/snehaadeshmukh_vega-hackathonexperience-hackathon-ugcPost-7171774307419766784-5xXa",
      img: Vega,
      position: "Top 10"
    }
  ],
  stats: {
    experience: "2+",
    hackathonWins: "3",
    projects: "15+"
  }
};

export type ProfileData = typeof profileData;